import React, {FC} from 'react';
import {useHistory} from 'react-router-dom';
import {H6} from '../H6';
import {Section} from '../Section';
import {OrderPaidProduct, TOrderDetail} from "../../types/types";
import {nToast} from "../../plugins/reactToast";
import { orderChangeAvailable } from '../../apis/orders';
import { useUserState } from '../../context/UserContext';

interface ProductSectionProps {
    content: any;
    className?: string;
    hideActions?: boolean;
    orderNumber?: string;
    shippingStatus?: 'DELIVERED' | 'IN_DELIVERY' | 'READY'
    selectedProducts?: OrderPaidProduct[];
    order: TOrderDetail
    allSelectButtonPressed?: () => void
}

export const ProductSection: FC<ProductSectionProps> = ({
                                                            content,
                                                            className = '',
                                                            hideActions = false,
                                                            orderNumber,
                                                            shippingStatus,
                                                            selectedProducts,
                                                            order,
                                                            allSelectButtonPressed,
                                                        }) => {
    const history = useHistory();
    const {isLoggedIn} = useUserState();

    const targetBasePath = isLoggedIn ? '/mypage/orders' : '/non-member';

    const movingData = isLoggedIn ? {products: selectedProducts} : {nOrder: order, products: selectedProducts};

    const isAllReturned = order.products.filter(product => product.latestRequest !== null).length === order.products.length;

    const isFinished = (order.status === 'CONFIRMED') || (order.status === 'CANCELED');

    const cannotExchangeAndReturn = shippingStatus !== 'DELIVERED' || isAllReturned || isFinished || selectedProducts?.length === 0

    const canCancel = selectedProducts?.filter(product => product.productStatus === 'PENDING').length === selectedProducts?.length && selectedProducts?.length !== 0;

    const canExchange = selectedProducts?.filter(product => (product.productStatus === 'DELIVERED' || product.productStatus === 'RETURNED')).length === selectedProducts?.length && selectedProducts?.length !== 0;

    return (
        <>
            <Section className={`${className}`}>
                <div
                    className="flex md:flex-row flex-col space-y-4 md:space-y-0 justify-between md:items-center pb-4 md:pb-0">
                    <H6>주문 상품정보</H6>

                    <div className="md:hidden border-b "/>
                    {!hideActions && orderNumber && (
                        <div className="whitespace-nowrap space-x-4 overflow-x-scroll no-scrollbar">
                            {/*<button*/}
                            {/*    className={`md:hidden inline-block text-13 bg-gray-100 px-3 py-2`}*/}
                            {/*    onClick={allSelectButtonPressed}*/}
                            {/*    disabled={true}*/}
                            {/*>*/}
                            {/*    전체 선택*/}
                            {/*</button>*/}
                            <button
                                className={`inline-block text-13 bg-gray-100 px-3 py-2 ${!canCancel ? 'text-gray-300' : ''}`}
                                disabled={!canCancel}
                                onClick={() => selectedProducts?.length === 0 ? nToast('상품을 선택해 주세요') :
                                    orderChangeAvailable(orderNumber)
                                        .then(() => history.push(`${targetBasePath}/${orderNumber}/cancel`, movingData))
                                        .catch(() => nToast('이미 배송준비중이라 변경이 불가합니다.'))
                                }
                            >
                                주문 취소
                            </button>
                            <button
                                className={`inline-block text-13 bg-gray-100 px-3 py-2 ${!canCancel ? 'text-gray-300' : ''}`}
                                disabled={!canCancel}
                                onClick={() => selectedProducts?.length === 0 ? nToast('상품을 선택해 주세요') :
                                    orderChangeAvailable(orderNumber)
                                        .then(() => history.push(`${targetBasePath}/${orderNumber}/edit-size`, movingData))
                                        .catch(() => nToast('이미 배송준비중이라 변경이 불가합니다.'))
                                }
                            >
                                사이즈 변경
                            </button>
                            <button
                                className={`inline-block text-13 bg-gray-100 px-3 py-2 ${(!canExchange) ? 'text-gray-300' : ''}`}
                                disabled={!canExchange}
                                onClick={() => selectedProducts?.length === 0 ? nToast('상품을 선택해 주세요') :
                                    history.push(`${targetBasePath}/${orderNumber}/exchange`, movingData)
                                }
                            >
                                교환 신청
                            </button>
                            <button
                                className={`inline-block text-13 bg-gray-100 px-3 py-2 ${(!canExchange) ? 'text-gray-300' : ''}`}
                                disabled={!canExchange}
                                onClick={() => selectedProducts?.length === 0 ? nToast('상품을 선택해 주세요') :
                                    history.push(`${targetBasePath}/${orderNumber}/refund`, movingData)
                                }
                            >
                                반품 신청
                            </button>
                        </div>
                    )}
                </div>
                {content}
            </Section>
        </>
    );
};
